import { ComponentPropsWithoutRef } from "react";
import clsx from "clsx";

type Props = {
  abbr: string;
  imageUrl?: string | null;
  width?: number;
  height?: number;
} & ComponentPropsWithoutRef<"div">;

/**
 * BST Styled Avatar
 * @param param - avatar props
 * @returns BST Styled Avatar image or text abbreviation
 */
export function Avatar({ className, abbr, width, height, imageUrl }: Props) {
  return (
    <div
      className={clsx("global-utilities__employee-avatar", className)}
      data-testid="employee-avatar"
      style={{ width, height }}
    >
      {imageUrl ? (
        <img
          data-testid="avatar-image"
          alt={abbr}
          src={imageUrl}
          width={width || 32}
          height={height || 32}
        />
      ) : (
        abbr
      )}
    </div>
  );
}
